import React from 'react';
import ReactDOM from 'react-dom/client';

import { checkBuildVersion } from './utils/buildVersionCheck';

import App from './App';
import { IS_MOCK_ENV, enableMocking } from './mocks/enableMocking';
import reportWebVitals from './reportWebVitals';
import { registerSW } from './serviceWorkerRegister';

import './assets/styles/default.scss';

async function bootstrap() {
  checkBuildVersion();

  if (IS_MOCK_ENV) {
    await enableMocking();
  } else {
    registerSW();
  }

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  reportWebVitals();
}

bootstrap();
